module.exports = __webpack_public_path__ + "656111ae909f8729b22b44d500bbecf2.png";